export var ENTITY = "system";
export var REDUCER_KEY = "SYSTEM_V2";
export var BASE_PATH_ENTITY = "system";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
